import { Radio } from '@seiue/ui'
import React from 'react'
import styled from 'styled-components'
import { DateTypeEnum } from './types'

/**
 * 问卷 - 题目设置 - 日期类型设置
 *
 * @param param - 参数
 * @param param.onChange - 选中状态变化触发事件
 * @param param.dateType - 当前选中的日期类型
 * @param param.isUserField - 是否是用户字段
 * @returns React.ReactNode
 */
export const DateSetting: React.FC<{
  onChange: (checked: boolean, checkedType: DateTypeEnum) => void
  dateType?: DateTypeEnum
  isUserField?: boolean
}> = ({ onChange, dateType, isUserField }) => {
  return (
    <DateRangeSettingWrapper>
      <Radio
        disabled={!!isUserField}
        checked={dateType !== DateTypeEnum.Time}
        onChange={(e) => onChange(e.target.checked, DateTypeEnum.Date)}
      >
        年-月-日
      </Radio>
      <Radio
        disabled={!!isUserField}
        checked={dateType === DateTypeEnum.Time}
        onChange={(e) => onChange(e.target.checked, DateTypeEnum.Time)}
      >
        年-月-日 时:分
      </Radio>
    </DateRangeSettingWrapper>
  )
}

const DateRangeSettingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  .ant-checkbox-wrapper {
    width: 100%;
    margin-left: 0;
    &:last-child {
      margin-top: 8px;
    }
  }
`
